import moment from "moment";
import i18n from "../i18n/i18n";

export const getFormattedDate = (date) =>
  date
    ? moment(date, "YYYY-MM-DDTHH:mm:ss.SSSSZ").format("YYYY-MM-DD HH:mm:ss")
    : "";

export const getConnectedStatusString = (connected) =>
  connected === undefined
    ? i18n.t("statuses.loading")
    : connected
      ? i18n.t("statuses.connected")
      : i18n.t("statuses.unconnected");

export const fromSecondsToHHMMSS = (inputSeconds) => {
  let hours = Math.floor(inputSeconds / 3600);
  let minutes = Math.floor((inputSeconds - hours * 3600) / 60);
  let seconds = inputSeconds - hours * 3600 - minutes * 60;

  if (hours < 10) {
    hours = "0" + hours;
  }
  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  if (seconds < 10) {
    seconds = "0" + seconds;
  }
  return hours + ":" + minutes + ":" + seconds;
};
